import { GlBadge, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'HiddenBadge',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    }
};
